import React from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Slide } from '@mui/material';
import { toggleAlert } from '../../actions';
import i18next from 'i18next';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const mapDispatchToProps = dispatch => ({
    toggleAlert: (payload) => dispatch(toggleAlert(payload))
});

const mapStateToProps = state => ({
    alert: state.global_alert || { show: false, title: '', message: '' }
});

class GlobalAlert extends React.Component {
    handleClose = () => {
        this.props.toggleAlert({ show: false });
    };

    render() {
        const { show, title, message } = this.props.alert;

        return (
            <Dialog
                open={show}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleClose}
                aria-describedby="alert-dialog-slide-description"
                sx={{
                    '& .MuiDialog-paper': {
                        borderRadius: 3,
                        padding: 1,
                        minWidth: 300
                    }
                }}
            >
                <DialogTitle sx={{ color: 'var(--color-primary)', fontWeight: 700 }}>
                    {title || i18next.t("attenzione") || "Attenzione"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={{ color: '#2d3748' }}>
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={this.handleClose}
                        sx={{
                            color: 'var(--color-primary)',
                            fontWeight: 600,
                            '&:hover': { bgcolor: 'rgba(1, 59, 112, 0.05)' }
                        }}
                    >
                        {i18next.t("chiudi") || "Chiudi"}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalAlert);
